import React from "react";
import * as styles from "./scrollIndicator.css.ts";

const ScrollIndicator: React.FC = () => {
  return (
    <div className={styles.scrollContainer}>
      <p className={styles.scrollText}>Scroll</p>
      <div className={styles.scrollLine}></div>
    </div>
  );
};

export default ScrollIndicator;
